import * as React from 'react';
import Hidden, { HiddenProps } from '@material-ui/core/Hidden';

const HiddenNext: React.SFC<HiddenProps> = props => <Hidden {...props} />;

export default HiddenNext;
